import React from 'react';
import {ContextMenuContainer, ContextMenuItem, OwnerInfo} from "./ContextMenu.styled";

export interface ContextMenuAction {
    key: string;
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
    color?: string;
    hidden?: boolean;
}

interface ContextMenuPropsType {
    id?: string;
    open: boolean;
    anchorEl?: HTMLElement | null;
    mouseX?: number;
    mouseY?: number;
    onClose: () => void;
    ownerEmail?: string;
    actions: ContextMenuAction[];
}

const ContextMenu = ({
    id,
    open,
    anchorEl,
    mouseX,
    mouseY,
    onClose,
    ownerEmail,
    actions,
}: ContextMenuPropsType) => {
    return (
        <ContextMenuContainer
            id={id}
            open={open}
            onClose={onClose}
            anchorEl={anchorEl ?? null}
            anchorReference={anchorEl ? 'anchorEl' : 'anchorPosition'}
            anchorPosition={
                mouseY !== undefined && mouseX !== undefined
                    ? {top: mouseY, left: mouseX}
                    : undefined
            }
            MenuListProps={{
                autoFocusItem: true,
                'aria-labelledby': id,
            }}
        >
            {ownerEmail && (
                <ContextMenuItem key="owner">
                    <OwnerInfo>{ownerEmail}</OwnerInfo>
                </ContextMenuItem>
            )}

            {actions
                .filter(action => !action.hidden)
                .map(action => (
                    <ContextMenuItem
                        key={action.key}
                        onClick={() => {
                            onClose();
                            action.onClick();
                        }}
                        style={action.color ? {color: action.color} : undefined}
                    >
                        {action.icon && (
                            <span style={{marginRight: '8px', width: '16px', height: '16px', display: 'flex'}}>
                                {action.icon}
                            </span>
                        )}
                        {action.label}
                    </ContextMenuItem>
                ))
            }
        </ContextMenuContainer>
    );
};

export default ContextMenu;